<h2>Lista dodanych utworów</h2>

<div style="display: block;margin:10px 0 10px 0">
   <form (submit)="onSearch()">
        <p-dropdown [options]="arangersList" [(ngModel)]="qp.user_id" (onChange)="onSearch()"  [ngModelOptions]="{standalone: true}" ></p-dropdown>

        <input style="margin-left: 20px;" type="text" pInputText [(ngModel)]="qp.search" placeholder="Fraza" [ngModelOptions]="{standalone: true}" >
        <button style="margin-left: 20px;" pButton type="submit" label="Szukaj" (click)="this.onSearch()"   ></button>
    </form>
</div>


<p-table [value]="this.notes" *ngIf="!isLoading && notes && notes.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th class="colTitle" style="width:50%">Tytuł utowru</th>
            <th class="colTitle" style="width:25%">Pobierz nuty</th>
            <th class="colTitle" style="width:25%">Pobierz dzwięk</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-note>
        <tr>
            <td style="width:50%">{{note.title}}</td>
            <td style="width:25%">
                <button
                (click)="this.download(note)" mat-button color="primary">Pobierz</button>
            </td>
            <td style="width:25%">
                <button
                (click)="this.downloadSound(note)" mat-button color="primary">Pobierz</button>
            </td>
        </tr>
    </ng-template>
</p-table>
<div *ngIf="!isLoading && this.notes.length == 0" style="display: flex;justify-content: center;">Brak utworów</div>
<app-loader *ngIf="isLoading"></app-loader>
<div style="height: 30px;"></div>
<p-paginator (onPageChange)="this.onPaginate($event)" *ngIf="!isLoading && notes.length > 0" [rows]="data.per_page"
    [totalRecords]="data.total"></p-paginator>
